import type {
  LC_UpdateCostCenterIn,
  LC_UpdateCostCenterOut,
  UpdateCostCenterRequest,
  UpdateCostCenterResult,
} from '../types';


export function mapUpdateCostCenterToTransport(
  request: UpdateCostCenterRequest,
): LC_UpdateCostCenterIn {
  return {
    costCenterCode: request.code,
    costCenterName: request.name,
    description: request.description,
  };
}

export function mapUpdateCostCenterFromTransport(
  transport: LC_UpdateCostCenterOut,
): UpdateCostCenterResult {
  return {
    id: transport.costCenterId,
    code: transport.costCenterCode,
    name: transport.costCenterName,
    description: transport.description,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
    modifiedDate: transport.modifiedDate || undefined,
    modifiedBy: transport.modifiedBy || undefined,
  };
}
